export default __webpack_public_path__ + "static/media/soul-blue-light.02bde444.png";